import { StateType } from "@/types";
import type { UserType } from "@/types/user";
import { Module } from "vuex";

const state = {
  user: {} as UserType,
  token: "",
  showLogin: false,
  showPaymentDialog: false,
  lang: "zh-CN",
  exchangeRate: 0,
  platform: "zh-CN",
  language: "zh-CN",
};
type UserStateType = typeof state;

const user: Module<UserStateType, StateType> = {
  namespaced: true,
  ...state,
};

export { UserStateType, state };
export default user;
